module.exports = __webpack_public_path__ + "static/img/8.a643820.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/eng/8.png
// module id = ALfe
// module chunks = 0